import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './schrift';
import { App } from './App';
import { Auffangnetz } from './komponenten/Auffangnetz';
import './stil.css';

/*
 * Der Umschalter für die Kopfvarianten (CRM-186) ist entfernt (CRM-193). Ein
 * Gerät, das noch eine Variante gespeichert hat, verliert sie hier; ohne die
 * Einfuhr setzt ohnehin niemand mehr `data-kopf`.
 */
try {
  window.localStorage.removeItem('crm.kopfvariante');
} catch {
  // Ohne Speicher (privates Fenster, gesperrt) gibt es auch nichts zu löschen.
}

const wurzel = document.getElementById('wurzel');

if (!wurzel) {
  throw new Error('Wurzelelement #wurzel fehlt');
}

createRoot(wurzel).render(
  <StrictMode>
    {/* Ohne dieses Netz nimmt ein Fehler beim Rendern den ganzen Baum mit und
        hinterlaesst eine weisse Seite ohne Text — genau der Totalverlust,
        gegen den ERR-11 geschrieben ist. */}
    <Auffangnetz>
      <App />
    </Auffangnetz>
  </StrictMode>,
);
